// import React from "react";

// export default function BankVerificationBox({ verification, className = "" }) {
//   if (!verification) return null;

//   const {
//     verify,
//     loading,
//     statusLoading,
//     alreadyVerified,
//     failed,
//     pending,
//     bypassed,
//     beneficiaryName,
//     result,
//     policy,
//     verificationRequired,
//     isValidInput,
//   } = verification;

//   const pennyDropEnabled = Boolean(policy?.pennyDropCharge?.enabled);
//   const pennyDropAmount = policy?.pennyDropCharge?.amount ?? 1;

//   return (
//     <div
//       className={`mt-2 rounded-lg border p-3 text-xs transition-all ${className} ${
//         alreadyVerified
//           ? "border-emerald-300 bg-emerald-50 text-emerald-900"
//           : failed
//           ? "border-red-300 bg-red-50 text-red-900"
//           : pending
//           ? "border-amber-300 bg-amber-50 text-amber-900"
//           : "border-[var(--border-color)] bg-[var(--bg-subtle,rgba(0,0,0,0.02))] text-[var(--text-muted)]"
//       }`}
//     >
//       {statusLoading ? (
//         <div className="flex items-center gap-2 text-slate-600">
//           <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
//             <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//             <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
//           </svg>
//           <span>Checking verification status...</span>
//         </div>
//       ) : alreadyVerified ? (
//         <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
//           <div className="flex items-start gap-2">
//             <svg className="w-4 h-4 text-emerald-600 mt-0.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
//             </svg>
//             <div>
//               <div className="flex items-center gap-2">
//                 <span className="font-semibold text-emerald-800">Bank Verified</span>
//                 {result?.provider && (
//                   <span className="text-[10px] bg-emerald-200 text-emerald-900 px-1.5 py-0.5 rounded font-mono">
//                     {result.provider}
//                   </span>
//                 )}
//               </div>
//               {beneficiaryName ? (
//                 <p className="mt-0.5 text-xs text-emerald-900">
//                   Registered Name: <strong className="font-semibold">{beneficiaryName}</strong>
//                 </p>
//               ) : (
//                 <p className="mt-0.5 text-[11px] text-emerald-700">Account verified with bank records.</p>
//               )}
//             </div>
//           </div>
//           <button
//             type="button"
//             onClick={() => verify({ forceReverify: true })}
//             disabled={loading}
//             className="self-end sm:self-center px-2.5 py-1 text-xs font-medium rounded border border-emerald-400 bg-white text-emerald-700 hover:bg-emerald-100 disabled:opacity-50 transition-colors flex items-center gap-1.5"
//             title="Dobara live verify karein"
//           >
//             <svg className={`w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//             </svg>
//             {loading ? "Verifying..." : "Dobara Verify"}
//           </button>
//         </div>
//       ) : bypassed ? (
//         <div className="flex items-center gap-2 text-amber-800">
//           <svg className="w-4 h-4 shrink-0 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
//           </svg>
//           <span>Verification Bypassed by Admin. Provider verification is not complete.</span>
//         </div>
//       ) : pending ? (
//         <div className="flex items-center gap-2 text-amber-800">
//           <svg className="w-4 h-4 shrink-0 text-amber-600 animate-spin" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//           </svg>
//           <span>Verification Pending with Bank. Please wait a moment...</span>
//         </div>
//       ) : failed ? (
//         <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
//           <div className="flex items-start gap-2">
//             <svg className="w-4 h-4 text-red-600 mt-0.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//             <div>
//               <span className="font-semibold text-red-800">Verification Failed</span>
//               <p className="mt-0.5 text-[11px] text-red-700">
//                 {result?.failureReason || result?.message || "Bank details could not be verified. Please check IFSC & account number."}
//               </p>
//             </div>
//           </div>
//           <button
//             type="button"
//             onClick={() => verify({ forceReverify: true })}
//             disabled={loading || !isValidInput}
//             className="self-end sm:self-center px-3 py-1 text-xs font-medium rounded bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 transition-colors flex items-center gap-1.5"
//           >
//             <svg className={`w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//             </svg>
//             {loading ? "Verifying..." : "Dobara Try Karein"}
//           </button>
//         </div>
//       ) : (
//         <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
//           <div>
//             <p className="text-[11px]">
//               {verificationRequired
//                 ? "Bank verification is compulsory before adding this account."
//                 : "Bank verification is optional."}
//               {verificationRequired && pennyDropEnabled && (
//                 <span className="font-medium text-[var(--text-dark)]">
//                   {" "}(Penny drop charge: ₹{pennyDropAmount})
//                 </span>
//               )}
//             </p>
//             {!isValidInput && (
//               <p className="mt-0.5 text-[10px] text-[var(--text-muted)]">
//                 Enter valid 9-18 digit account number & 11-digit IFSC to verify.
//               </p>
//             )}
//           </div>
//           {verificationRequired && (
//             <button
//               type="button"
//               onClick={() => verify()}
//               disabled={loading || !isValidInput}
//               className="self-end sm:self-center px-3 py-1.5 text-xs font-medium rounded bg-[var(--primary-color,#2563eb)] text-white hover:opacity-90 disabled:opacity-50 transition-opacity flex items-center gap-1.5"
//             >
//               <svg className={`w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//               {loading ? "Verifying..." : "Verify Bank"}
//             </button>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }




// import React from "react";

// export default function BankVerificationBox({ verification, className = "" }) {
//   if (!verification) return null;

//   const {
//     verify,
//     loading,
//     statusLoading,
//     alreadyVerified,
//     failed,
//     pending,
//     bypassed,
//     result,
//     policy,
//     verificationRequired,
//     isValidInput,
//   } = verification;

//   const pennyDropEnabled = Boolean(policy?.pennyDropCharge?.enabled);
//   const pennyDropAmount = policy?.pennyDropCharge?.amount ?? 1;

//   const btnBase =
//     "px-3 py-2 text-xs font-medium rounded whitespace-nowrap disabled:opacity-50 transition-opacity";

//   // Button ke niche sirf charge
//   const chargeText = pennyDropEnabled ? (
//     <p className="m-0 text-[11px] font-medium text-[var(--text-muted)]">
//       Charge: ₹{pennyDropAmount}
//     </p>
//   ) : null;

//   return (
//     <div className={`flex flex-col items-start gap-1 ${className}`}>
//       {statusLoading ? (
//         <span className="text-xs text-[var(--text-muted)]">
//           Checking status...
//         </span>
//       ) : bypassed ? (
//         <span className="text-xs text-amber-700">
//           Verification bypassed by admin
//         </span>
//       ) : pending ? (
//         <span className="text-xs text-amber-700">
//           Verification pending with bank...
//         </span>
//       ) : alreadyVerified ? (
//         <>
//           {/* Ek hi button: verified tick + Dobara Verify (name form me pehle se auto-fill hota hai) */}
//           <button
//             type="button"
//             onClick={() => verify({ forceReverify: true })}
//             disabled={loading}
//             className={`${btnBase} flex items-center gap-1.5 border border-emerald-400 bg-emerald-50 text-emerald-700 hover:bg-emerald-100`}
//             title="Bank Verified - dobara live verify karein"
//           >
//             <svg
//               className="w-4 h-4 shrink-0 text-emerald-600"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//               aria-hidden="true"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="3"
//                 d="M5 13l4 4L19 7"
//               />
//             </svg>
//             {loading ? "Verifying..." : "Again Verify"}
//           </button>

//           {chargeText}
//         </>
//       ) : failed ? (
//         <>
//           <button
//             type="button"
//             onClick={() => verify({ forceReverify: true })}
//             disabled={loading || !isValidInput}
//             className={`${btnBase} bg-red-600 text-white hover:bg-red-700`}
//           >
//             {loading ? "Verifying..." : "Try Again"}
//           </button>

//           {chargeText}

//           <p className="m-0 text-[11px] text-red-700">
//             {result?.failureReason ||
//               result?.message ||
//               "Verification failed. Check IFSC & account number."}
//           </p>
//         </>
//       ) : verificationRequired ? (
//         <>
//           <button
//             type="button"
//             onClick={() => verify()}
//             disabled={loading || !isValidInput}
//             className={`${btnBase} bg-[var(--primary-color,#2563eb)] text-white hover:opacity-90`}
//           >
//             {loading ? "Verifying..." : "Verify Bank"}
//           </button>

//           {chargeText}
//         </>
//       ) : (
//         <span className="text-xs text-[var(--text-muted)]">
//           Verification optional  
//         </span>
//       )}
//     </div>
//   );
// }
























// import React from "react";

// export default function BankVerificationBox({ verification, className = "" }) {
//   if (!verification) return null;

//   const {
//     verify,
//     loading,
//     statusLoading,
//     alreadyVerified,
//     failed,
//     pending,
//     bypassed,
//     result,
//     policy,
//     verificationRequired,
//     isValidInput,
//   } = verification;

//   const pennyDropEnabled = Boolean(policy?.pennyDropCharge?.enabled);
//   const pennyDropAmount = policy?.pennyDropCharge?.amount ?? 1;

//   const btnBase =
//     "px-3 py-2 text-xs font-medium rounded whitespace-nowrap disabled:opacity-50 transition-opacity";

//   const chargeText = pennyDropEnabled ? (
//     <p className="m-0 text-[11px] font-medium text-[var(--text-muted)]">
//       Charge: ₹{pennyDropAmount}
//     </p>
//   ) : null;

//   return (
//     <div className={`flex flex-col items-start gap-1 ${className}`}>
//       {statusLoading ? (
//         <span className="text-xs text-[var(--text-muted)]">
//           Checking status...
//         </span>
//       ) : bypassed ? (
//         <span className="text-xs text-amber-700">
//           Verification bypassed by admin
//         </span>
//       ) : pending ? (
//         <span className="text-xs text-amber-700">
//           Verification pending with bank...
//         </span>
//       ) : alreadyVerified ? (
//         <>
//           <button
//             type="button"
//             onClick={() => verify({ forceReverify: true })}
//             disabled={loading || !isValidInput}
//             className={`${btnBase} flex items-center gap-1.5 border border-emerald-400 bg-emerald-50 text-emerald-700 hover:bg-emerald-100`}
//             title="Bank Verified - dobara live verify karein"
//           >
//             <svg
//               className="w-4 h-4 shrink-0 text-emerald-600"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//               aria-hidden="true"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="3"
//                 d="M5 13l4 4L19 7"
//               />
//             </svg>
//             {loading ? "Verifying..." : "Again Verify"}
//           </button>

//           {chargeText}
//         </>
//       ) : failed ? (
//         <>
//           <button
//             type="button"
//             onClick={() => verify({ forceReverify: true })}
//             disabled={loading || !isValidInput}
//             className={`${btnBase} bg-red-600 text-white hover:bg-red-700`}
//           >
//             {loading ? "Verifying..." : "Try Again"}
//           </button>

//           {chargeText}

//           {/* <p className="m-0 text-[11px] text-red-700">
//             {result?.failureReason ||
//               result?.message ||
//               "Verification failed. Check IFSC & account number."}
//           </p> */}
//         </>
//       ) : (
//         <>
//           <button
//             type="button"
//             onClick={() => verify()}
//             disabled={loading || !isValidInput}
//             className={`${btnBase} bg-[var(--primary-color,#2563eb)] text-white hover:opacity-90`}
//             title={
//               verificationRequired
//                 ? "Verify bank account"
//                 : "Optional bank verification"
//             }
//           >
//             {loading ? "Verifying..." : "Verify Bank"}
//           </button>

//           {chargeText}
//         </>
//       )}
//     </div>
//   );
// }



// with confirmation 

import React, { useState } from "react";
import ConfirmDialog from "./ui/ConfirmDialog";
// Path apne project ke hisaab se adjust karo


export default function BankVerificationBox({ verification, className = "" }) {
  // Hooks hamesha early return se pehle hone chahiye
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingOptions, setPendingOptions] = useState(undefined);

  if (!verification) return null;

  const {
    verify,
    loading,
    statusLoading,
    alreadyVerified,
    failed,
    pending,
    bypassed,
    result,
    policy,
    verificationRequired,
    isValidInput,
  } = verification;

  const pennyDropEnabled = Boolean(policy?.pennyDropCharge?.enabled);
  const pennyDropAmount = policy?.pennyDropCharge?.amount ?? 1;

  const btnBase =
    "px-3 py-2 text-xs font-medium rounded whitespace-nowrap disabled:opacity-50 transition-opacity";

  const chargeText = pennyDropEnabled ? (
    <p className="m-0 text-[11px] font-medium text-[var(--text-muted)]">
      Charge: ₹{pennyDropAmount}
    </p>
  ) : null;

  /* ---------- confirmation handlers ---------- */
  // Button click par seedha verify nahi, pehle dialog kholo
  const askConfirm = (options) => {
    setPendingOptions(options);
    setConfirmOpen(true);
  };

  const handleCancel = () => {
    if (loading) return;
    setConfirmOpen(false);
    setPendingOptions(undefined);
  };

  const handleConfirm = () => {
    setConfirmOpen(false);
    const options = pendingOptions;
    setPendingOptions(undefined);
    if (options) {
      verify(options);
    } else {
      verify();
    }
  };

  const isReverify = Boolean(pendingOptions?.forceReverify);

  const confirmTitle = isReverify ? "Verify bank again?" : "Verify bank account?";

  const confirmMessage = pennyDropEnabled
    ? `A bank verification charge of ₹${pennyDropAmount} will be deducted from your wallet${
        isReverify ? " for this re-verification" : ""
      }. Do you want to continue?`
    : isReverify
    ? "This will run a live bank verification again. Do you want to continue?"
    : "This will start the bank account verification. Do you want to continue?";

  return (
    <div className={`flex flex-col items-start gap-1 ${className}`}>
      {statusLoading ? (
        <span className="text-xs text-[var(--text-muted)]">
          Checking status...
        </span>
      ) : bypassed ? (
        <span className="text-xs text-amber-700">
          Verification bypassed by admin
        </span>
      ) : pending ? (
        <span className="text-xs text-amber-700">
          Verification pending with bank...
        </span>
      ) : alreadyVerified ? (
        <>
          <button
            type="button"
            onClick={() => askConfirm({ forceReverify: true })}
            disabled={loading || !isValidInput}
            className={`${btnBase} flex items-center gap-1.5 border border-emerald-400 bg-emerald-50 text-emerald-700 hover:bg-emerald-100`}
            title="Bank Verified - dobara live verify karein"
          >
            <svg
              className="w-4 h-4 shrink-0 text-emerald-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M5 13l4 4L19 7"
              />
            </svg>
            {loading ? "Verifying..." : "Again Verify"}
          </button>

          {chargeText}
        </>
      ) : failed ? (
        <>
          <button
            type="button"
            onClick={() => askConfirm({ forceReverify: true })}
            disabled={loading || !isValidInput}
            className={`${btnBase} bg-red-600 text-white hover:bg-red-700`}
          >
            {loading ? "Verifying..." : "Try Again"}
          </button>

          {chargeText}

          {/* <p className="m-0 text-[11px] text-red-700">
            {result?.failureReason ||
              result?.message ||
              "Verification failed. Check IFSC & account number."}
          </p> */}
        </>
      ) : (
        <>
          <button
            type="button"
            onClick={() => askConfirm()}
            disabled={loading || !isValidInput}
            className={`${btnBase} bg-[var(--primary-color,#2563eb)] text-white hover:opacity-90`}
            title={
              verificationRequired
                ? "Verify bank account"
                : "Optional bank verification"
            }
          >
            {loading ? "Verifying..." : "Verify Bank"}
          </button>

          {chargeText}
        </>
      )}

      <ConfirmDialog
        open={confirmOpen}
        title={confirmTitle}
        message={confirmMessage}
        confirmLabel="Yes, Verify"
        cancelLabel="Cancel"
        confirmColor="primary"
        loading={false}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </div>
  );
}